import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { listarProvinciasHogarFetch,listarRelatividadesHogarFetch, recuperarDatosFacturacionFetch} from "../../redux/actions/aCotizacion";
import { FetchListarCarritoHogar,setProductoActualCotizadoHogar,LimpiarCarritoHogar,limpiarProductoActualCotizadoHogar, FetchDataSeccionesCoberturasHogar,FetchTotalesCabeceraCotizadores} from "../../redux/actions/ACarritoProductos";
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";



class ContainerRecuperarCotizacionHogar extends React.Component {
  constructor(props) {
    super(props);
  }

  async componentDidMount() {

    var codigo = this.props.datosCarritoHogar.setCarritoHogar.carDescripcionSeguro == 'HOGAR ADVANCE' ? 'hogar-advance': 'hogar'
    await this.props.limpiarProvinciasHogar(codigo);
    let datosRelatividades =
    {
      "empresa":"AIGMETROPOLITANA",
      "ramo": codigo=='hogar' ?"Hogar": 'Hogar Advance'
    }
    await this.props.listarRelatividadesHogar(datosRelatividades);
    //Listar Carrito Hogar
    const queryParams = new URLSearchParams(this.props.location.search);
    const idCarrito=queryParams.get('idCarrito');
    let datosCarritoHogar =
    {
      "empresa":"AIGMETROPOLITANA",
      "idCarrito":idCarrito
    }
    // actualizar los datos del cotizadores                          
    let datosJSON = {
      empresa:"AIGMETROPOLITANA",
      plataforma:"WEB",
      idCarrito: idCarrito
    }     
    await this.props.listarSeccionesCotizador(datosCarritoHogar);
    await this.props.limpiarCarrito();
    await this.props.listarCarritoHogar(datosCarritoHogar);
    await this.props.limpiarProductoActual();         
    await this.props.datosFacturacion(datosJSON); 

    if(this.props.dataFacturacion !== undefined && this.props.dataFacturacion !== "")
    {              
      let param={
        pathIcono:this.props.dataFacturacion.pathIconoTotalesCabecera?this.props.dataFacturacion.pathIconoTotalesCabecera:"", 
        totalItems:this.props.dataFacturacion.numItemsCarrito?this.props.dataFacturacion.numItemsCarrito:"0", 
        totalPrima:(this.props.dataFacturacion.carValoresTotales && this.props.dataFacturacion.carValoresTotales.primaTotal)?this.props.dataFacturacion.carValoresTotales.primaTotal:"0.00", 
        ramoCotizador:this.props.dataFacturacion.carDescripcionRamo?this.props.dataFacturacion.carDescripcionRamo:"", 
      }
      await this.props.actualizarTotalesCabecera(param);
    }

    //Set valores del producto actual
    if(this.props.datosCarritoHogar.setCarritoHogar && this.props.datosCarritoHogar.setCarritoHogar.carCodigoProductoActual)
    {
      let ObtenerProducto = this.props.datosCarritoHogar.setCarritoHogar.carProductos.filter((item) =>
      item.codigo === this.props.datosCarritoHogar.setCarritoHogar.carCodigoProductoActual)        
      ObtenerProducto = ObtenerProducto[0];         
      await this.props.setProductoActual(ObtenerProducto);
    }


    //Redireccionar al paso correspondiente
    let obtenerPaso=this.props.datosCarritoHogar.setCarritoHogar.pasoCarrito;    
    if(obtenerPaso==="inicioCarrito")
    {
      this.props.history.push({
          pathname: `/cotizacion-hogar`,
          search: `recuperar=true`, //agregar parametros de la url,
      });
    }
    else if(obtenerPaso === "inicioUbicacion"){
      this.props.history.push({
          pathname: `/cotizacion-hogar-paso2`,
          search: `recuperar=true`, //agregar parametros de la url,
      });
    }
    else if(obtenerPaso === "seleccionConstruccion"){
      this.props.history.push({
          pathname: `/cotizacion-hogar-paso3`,
          search: `recuperar=true`, //agregar parametros de la url,
      });
    }
    else if(obtenerPaso === "protecciones"){
      this.props.history.push({
          pathname: `/cotizacion-hogar-paso4`,
          search: `recuperar=true`, //agregar parametros de la url,
      });
    }
    else if(obtenerPaso === "resumenCotizacionHogar"){
      this.props.history.push({
        pathname: "/cotizacion-hogar-paso5",
        search: `?idCarrito=${idCarrito}`
  
      });
    }
    else if(obtenerPaso === "datosFacturacionHogar"){
      this.props.history.push({
        pathname: "/datos-facturacion",
        search: `?id=${idCarrito}`
  
      });
    }
  }

  render() {    
    return (
      <main className="bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">   
          <LoadingScreen
            loading={true}
            bgColor="#f1f1f1"
            spinnerColor="#001871"
            textColor="#676767"
            logoSrc={logo}
            text="Recuperando..."
          ><div></div></LoadingScreen>                           
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => ({  
  datosCarritoHogar : state.datosCarritoHogar,
  dataFacturacion : state.dataFacturacion.datosFacturacion
});

const mapDispatchToProps = dispatch => {
  return {
    limpiarProvinciasHogar: (ramo) => dispatch(listarProvinciasHogarFetch(ramo)),
    listarRelatividadesHogar: (param) => dispatch(listarRelatividadesHogarFetch(param)),
    limpiarCarrito:()=> dispatch(LimpiarCarritoHogar()),
    listarCarritoHogar: (param) => dispatch(FetchListarCarritoHogar(param)),
    setProductoActual:(param)=>dispatch(setProductoActualCotizadoHogar(param)),
    listarSeccionesCotizador:(param)=>dispatch(FetchDataSeccionesCoberturasHogar(param)),
    limpiarProductoActual:()=>dispatch(limpiarProductoActualCotizadoHogar()),
    datosFacturacion: (data) => dispatch(recuperarDatosFacturacionFetch(data)),
    actualizarTotalesCabecera:(param) => dispatch(FetchTotalesCabeceraCotizadores(param)), 
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContainerRecuperarCotizacionHogar)
);
